var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_44108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.316 1.29004H2.09853C1.49429 1.29004 1.00488 1.77945 1.00488 2.38369V16.6011C1.00488 17.2054 1.49429 17.6948 2.09853 17.6948H16.316C16.9202 17.6948 17.4096 17.2054 17.4096 16.6011V2.38369C17.4096 1.77945 16.9202 1.29004 16.316 1.29004Z",
    fill: "#427687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4547 1.29004H2.03018C1.46559 1.29414 1.00899 1.75074 1.00489 2.31534V15.6989C1.00352 16.2648 1.46148 16.7228 2.02745 16.7242C2.02882 16.7242 2.02882 16.7242 2.03018 16.7242H15.4411C16.007 16.7255 16.465 16.2676 16.4664 15.7016C16.4664 15.7002 16.4664 15.7002 16.4664 15.6989V2.31534C16.4787 1.76168 16.0385 1.30234 15.4848 1.29004C15.4752 1.29004 15.4643 1.29004 15.4547 1.29004Z",
    fill: "#8CAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9624 8.74063L11.6815 5.45968C11.4518 5.26282 11.1073 5.29016 10.9104 5.51983C10.8271 5.61689 10.7806 5.74129 10.7792 5.86979V7.78368C10.7792 7.93406 10.6562 8.05709 10.5058 8.05709H7.36155C7.21117 8.05709 7.08814 7.93406 7.08814 7.78368V5.86979C7.0854 5.56767 6.83797 5.3257 6.53585 5.32844C6.40734 5.3298 6.28294 5.37628 6.18588 5.45968L2.90493 8.74063C2.678 8.94022 2.65612 9.28608 2.85708 9.51302C2.87212 9.53079 2.88852 9.54583 2.90493 9.56086L6.18588 12.8418C6.41554 13.0387 6.76004 13.0113 6.9569 12.7817C7.04029 12.6846 7.08677 12.5602 7.08814 12.4317V10.5178C7.08814 10.3674 7.21117 10.2444 7.36155 10.2444H10.5058C10.6562 10.2444 10.7792 10.3674 10.7792 10.5178V12.4317C10.7819 12.7338 11.0294 12.9758 11.3315 12.973C11.46 12.9717 11.5844 12.9252 11.6815 12.8418L14.9624 9.56086C15.1894 9.37631 15.2235 9.04275 15.039 8.81718C15.0157 8.78984 14.9911 8.76387 14.9624 8.74063Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.88491 2.50698C5.88491 2.19256 5.66618 2.09686 4.40848 2.13787C3.35584 2.17889 2.83636 2.30192 2.52194 2.6847C2.20751 3.06748 2.12549 3.8467 2.11182 4.7763C2.11182 5.43249 2.11182 6.04767 2.45358 6.04767C2.91838 6.04767 2.91838 4.96769 3.30116 4.36619C4.03937 3.17684 5.88491 2.9171 5.88491 2.50698Z",
    fill: "#B4E1ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_44108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4984,
    height: 17.4984,
    fill: "white",
    transform: "translate(0.39502 0.749023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRight);
export default __webpack_public_path__ + "static/media/arrow-left-right.258272009aad46bd15a1f84eb8252279.svg";
export { ForwardRef as ReactComponent };